import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ResponseData } from "../common"

export interface ValidateGoogleTokenRequest
  extends Partial<AxiosRequestConfig> {
  params: { token: string }
}

interface ValidateGoogleTokenResponseData extends ResponseData {
  body: {
    firstName: string
    lastName: string
    emailAddress: string
    softLogin?: boolean | null
  }
  errorCode:
    | "api_email_already_exist"
    | "api_user_not_found"
    | "api_user_has_been_blocked"
    | "token_invalid"
    | 111008
}

export interface ValidateGoogleTokenResponse extends AxiosResponse {
  data: ValidateGoogleTokenResponseData
}

export function validateGoogleTokenAPI(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/auth/google/validate-token",
  }) as Promise<ValidateGoogleTokenResponse>
}
